import React from 'react';
import { ArrowUp, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black text-white py-12 sm:py-16 md:py-20 border-t border-white/5">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Back to Top Button */}
        <div className="flex justify-center mb-10 sm:mb-12 md:mb-16">
          <button
            onClick={scrollToTop}
            className="relative w-20 sm:w-24 md:w-32 h-20 sm:h-24 md:h-32 group">

            <div className="absolute inset-0 rounded-full border border-white/20 group-hover:border-red-500 transition-colors duration-300 animate-spin-slow">
              <svg className="w-full h-full" viewBox="0 0 100 100">
                <path
                  id="backToTopPath"
                  d="M 50, 50 m -40, 0 a 40,40 0 1,1 80,0 a 40,40 0 1,1 -80,0"
                  fill="none" />

                <text className="text-[6px] fill-white uppercase tracking-widest group-hover:fill-red-500 transition-colors">
                  <textPath href="#backToTopPath">
                    BACK TO TOP • BACK TO TOP • BACK TO TOP •
                  </textPath>
                </text>
              </svg>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <ArrowUp size={20} className="text-white group-hover:text-red-500 transition-colors sm:w-8 sm:h-8 md:w-8 md:h-8" />
            </div>
          </button>
        </div>

        {/* Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 md:gap-12 mb-8 sm:mb-10 md:mb-12">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_homepage-redesign-26/artifacts/yvkqg1i6_2%20copy.png"
              alt="GAFF Logo"
              className="h-20 sm:h-24 md:h-32 w-auto mb-3 sm:mb-4" />

            <p className="text-gray-400 text-xs sm:text-sm">
              Celebrating the finest cinema from across Asia.
            </p>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-widest mb-3 sm:mb-4 text-gray-400 font-semibold">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/gaff-2026" className="text-xs sm:text-sm hover:text-red-500 transition-colors">
                  GAFF 2026
                </a>
              </li>
              <li>
                <a href="/gaff-2025" className="text-xs sm:text-sm hover:text-red-500 transition-colors">
                  GAFF 2025
                </a>
              </li>
              <li>
                <a href="/about" className="text-xs sm:text-sm hover:text-red-500 transition-colors">
                  ABOUT
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-widest mb-3 sm:mb-4 text-gray-400 font-semibold">
              Contact
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm text-gray-400">
              <li>Guwahati, Assam, India</li>
              <li>contact@gaff.co.in</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-widest mb-3 sm:mb-4 text-gray-400 font-semibold">
              Follow Us
            </h4>
            <div className="flex gap-2 sm:gap-4">
              <a
                href="https://facebook.com/gaffindia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 sm:w-10 h-8 sm:h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-red-500 hover:border-red-500 transition-all duration-300 group"
              >
                <Facebook size={16} className="text-white group-hover:scale-110 transition-transform sm:w-5 sm:h-5" />
              </a>
              <a
                href="https://x.com/gaff_india"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 sm:w-10 h-8 sm:h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-red-500 hover:border-red-500 transition-all duration-300 group"
              >
                <svg 
                  viewBox="0 0 24 24" 
                  className="w-4 sm:w-5 h-4 sm:h-5 text-white group-hover:scale-110 transition-transform"
                  fill="currentColor"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://instagram.com/gaffindia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 sm:w-10 h-8 sm:h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-red-500 hover:border-red-500 transition-all duration-300 group"
              >
                <Instagram size={16} className="text-white group-hover:scale-110 transition-transform sm:w-5 sm:h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 sm:pt-8 border-t border-white/5">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-500">
            <p>
              Presented by <a href="https://trendingnowmedia.com" target="_blank" rel="noopener noreferrer" className="text-white font-semibold hover:text-red-500 transition-colors">Trending Now Media</a>
            </p>
            <p className="text-center">
              © 2027 Guwahati Asian Film Festival. All rights reserved.
            </p>
            <p>
              Powered by <a href="https://www.instagram.com/alchemypixels" target="_blank" rel="noopener noreferrer" className="text-white font-semibold hover:text-red-500 transition-colors">Alchemy Pixels</a>
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
      `}</style>
    </footer>);

};

export default Footer;
